<footer>

    <div class="main-footer">

        <div class="footer_flex">
            <p>Copyright © {{latestYear}} | All rights reserved.</p>

            <!-- <img src="assets/images/newworks-logo.png"> -->
        </div>

    </div>

</footer>